export const isAuthenticatedSelector = (state) => state.user.token !== undefined;
export const userSelector = (state) => state.user.user;
export const testSelector = (state) => state.user.test;
export const cartSelector = (state) => state.user.cart;
